<template>
    <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Certification</h2>
        <label class="uk-form-label">Certification Name</label>

        <div class="uk-form-controls">
            {{ name }}
        </div>
        <label class="uk-form-label">Validity Period</label>

        <div class="uk-form-controls uk-margin-medium-bottom">
            {{ duration }}
        </div>
        <button class="uk-button uk-button-primary uk-modal-close" type="button" :uk-toggle="'target: #' + modalId" @click="editForm">Edit</button>
        <button class="uk-button uk-button-tertiary uk-modal-close" type="button">Cancel</button>
    </div>
</template>

<script>
    export default {

        props: {
            modalId:String,
            formRef:String
        },

        data(){
            return {
                get:"/api/certs/get/",
                id:null,
                name:"",
                duration: ""
            }
        },

        methods:{
            editForm(){
                this.$root.$refs[this.formRef].loadForm(this.id);
            },
            loadForm(id){
                this.id = id;
                axios.get(this.get + id).then((pack) => this.updateFormData(pack));
            },
            updateFormData(pack){
                let data = pack.data.data;
                this.name = data.name;
                this.duration = data.valid_period;
            }
        }


    }
</script>
